module.exports = __webpack_public_path__ + "static/user-9d21eb53c7cd38a771968181c6943076.png";